export default "__VITE_ASSET__CYuUz80S__"